// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__5Ap6Q","header":"error_header__4ubHH"};